import React from "react";
import logger from "logger";
import TaskDialog from "TaskDialogCommon/TaskDialog";
import RunButton from "TaskDialogCommon/RunButton";
import { StringSelect } from "TaskDialogCommon/StringSelect";
import errordialog from "Common/errordialog";

const taskname = "upgrademounttomax";

export default function(props) {
  const { AccountDetailData, accountdetailrow } = props;
  const [taskConfig, setTaskConfig] = React.useState({
    accountdetail: accountdetailrow,
    mountId: "",
  });

  const mounts = AccountDetailData.mounts;

  if (!mounts) {
    errordialog.showError(
      "Mount Data Not Found. Please refresh or contact administrator."
    );
    return null;
  }

  const validate = () => {
    if (taskConfig.mountId === null || taskConfig.mountId === "") {
      alert("Please select a valid mount before continuing");
      return false;
    }
    return true;
  };

  return (
    <TaskDialog heading={"Upgrade Mount Level"}>
      <StringSelect
        label={"Select Mount"}
        param={"mountId"}
        setTaskConfigChanges={(taskConfigChanges) => {
          setTaskConfig({ ...taskConfig, ...taskConfigChanges });
        }}
        taskConfig={taskConfig}
        optionObject={mounts}
        labelParser={(k, v) => v.title + "(Lv:" + v.level + ")"}
        valueParser={(k, v) => v.id}
      />

      <RunButton
        taskname={taskname}
        taskConfig={taskConfig}
        label={"Upgrade Mount"}
        validate={validate}
      />
    </TaskDialog>
  );
}
